export type SmsInfo = {
	len: number
	seg: number
}

export function getSmsInfo(text: string): SmsInfo {
	const len = text.length
	if (len === 0) {
		return { len: 0, seg: 0 }
	}
	if (len <= 70) {
		return { len, seg: 1 }
	}
	return { len, seg: Math.ceil(len / 67) }
}
